<template>
    <div>
        <RequestTimelineComponent :contractDetails="contractDetails" />
        <ContractMainDetailsComponent :contractDetails="contractDetails" />
        <ContractPartnersComponent :contractDetails="contractDetails" />
        <ContractMilestonesComponent :contractDetails="contractDetails" />
        <!--<ContractDurationComponent :contractDetails="contractDetails" />-->
        <ContractTextComponent :contractDetails="contractDetails" />

    </div>
</template>
<script lang="ts">
    import { Component, Prop, Vue } from 'vue-property-decorator';

    import { ContractDetails } from '@/models/contract.model';
    import ContractPartnersComponent from './contract-partners.component.vue';
    import RequestTimelineComponent from './request-timeline.component.vue';
    import ContractDurationComponent from './contract-duration.component.vue';
    import ContractTextComponent from './contract-text.component.vue';
    import ContractMilestonesComponent from './contract-milestones.component.vue';
    import ContractMainDetailsComponent from './contract-main-details.component.vue';
    import { moduleProxy } from '@/store';
    import { HeaderModel } from '@/models/headerModel';

    @Component({
        components: {
            RequestTimelineComponent,
            ContractMainDetailsComponent,
            ContractPartnersComponent,
            ContractDurationComponent,
            ContractTextComponent,
            ContractMilestonesComponent,
        },
    })
    export default class ContractBodyComponent extends Vue {
        @Prop({ required: true }) contractDetails!: ContractDetails;

        mounted() {
            this.fillHeaderModel();
        }

        fillHeaderModel() {
            if (this.contractDetails) {
                const headerModel = {
                    contractCode: this.contractDetails.contractCode,
                    contractStatusId: this.contractDetails.contractStatusId,
                    contractStatusName: this.contractDetails.contractStatusName,
                    contractCreatedDate: this.contractDetails.createdDate,
                    contractEndDate: this.contractDetails.endDate.gregDate,
                    contractName: this.contractDetails.contractName,
                    contractStartDate: this.contractDetails.startDate.gregDate,
                    contractUpdatedDate: this.contractDetails.updatedDate,
                    remainingHours: this.contractDetails.remainingHours,
                    remainingHoursPercent: this.contractDetails.remainingHoursPercent,
                    requestCode: this.contractDetails.requestCode,
                    requestTypeName: this.contractDetails.requestTypeName,
                    requestStatusId: this.contractDetails.requestStatusId,
                    requestStatusName: this.contractDetails.requestStatusName,
                } as HeaderModel;
                moduleProxy.Header.setHeaderData(headerModel);
            }
        }
    }
</script>
